import { render } from "./ConfirmMnemonic.vue?vue&type=template&id=44a53b5a&scoped=true"
import script from "./ConfirmMnemonic.vue?vue&type=script&lang=ts"
export * from "./ConfirmMnemonic.vue?vue&type=script&lang=ts"

import "./ConfirmMnemonic.vue?vue&type=style&index=0&id=44a53b5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-44a53b5a"

export default script